import React from "react";
import Footer from "../Footer/footer";

const Fixedbg = () =>{
  return(
<>
<div className="fixed-bgf">
{/* <Footer/> */}
</div>

</>
  )}
export default Fixedbg;